import { captureEvent } from '../../../../../services/event-capture';

export type WeatherLocationFavouriteSource = 'weather page' | 'weather search';

export interface WeatherLocationFavouriteAnalyticsPayload {
  source: WeatherLocationFavouriteSource;
  itemType: string;
  latitude?: number;
  longitude?: number;
  markerType?: string;
}

export const trackWeatherLocationFavouriteAdded = (
  payload: WeatherLocationFavouriteAnalyticsPayload,
) => {
  captureEvent({
    type: 'Weather location favourite: add',
    payload,
    sendToAmplitude: true,
  });
};

export const trackWeatherLocationFavouriteRemoved = (
  payload: WeatherLocationFavouriteAnalyticsPayload,
) => {
  captureEvent({
    type: 'Weather location favourite: remove',
    payload,
    sendToAmplitude: true,
  });
};

export const trackWeatherLocationFavouriteSelected = (
  payload: WeatherLocationFavouriteAnalyticsPayload,
) => {
  captureEvent({
    type: 'Weather location favourite: select',
    payload,
    sendToAmplitude: true,
  });
};

export const buildWeatherLocationFavouriteAnalyticsPayload = ({
  source,
  itemType,
  latitude,
  longitude,
  markerType,
}: {
  source: WeatherLocationFavouriteSource;
  itemType: string;
  latitude?: number | null;
  longitude?: number | null;
  markerType?: string | null;
}): WeatherLocationFavouriteAnalyticsPayload => ({
  source,
  itemType,
  latitude: latitude ?? undefined,
  longitude: longitude ?? undefined,
  markerType: markerType || undefined,
});
